export default __webpack_public_path__ + "static/media/level2WiredLearnMore.0b6becd0.png";